import _ from 'lodash';
function CompareTwoObjects(o1, o2) {
  // o1 && typeof o1 === 'object' && Object.keys(o1).length > 0
  //   ? Object.keys(o1).length === Object.keys(o2).length &&
  //       Object.keys(o1).every((p) => CompareTwoObjects(o1[p], o2[p]))
  //   : o1 === o2;
  return _.isEqual(o1, o2);
}

export default CompareTwoObjects;
